export default {"src":"/_next/static/media/liechtenstein.3c561a88.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};